<div class="bg-color2 p-4">
    <div class="margin-bottom-10 header-section d-flex justify-content-between align-items-center">
        <div class="page-sub-heading">
            <h2 class="mb-0">{{'LeaderBoard.PageTitle3M' | translate}}</h2>
        </div>
        <div class="d-flex justify-content-end align-items-center">
            <label class="mb-0 pr-2">{{'LeaderBoard.SelectQuarter' | translate}}</label>
            <select [formControl]="selectQuarter" class="form-control select-status mr-0">
                <option value="">{{'LeaderBoard.SelectTheQuarter' | translate}}</option>
                <option *ngFor="let item of leaderboardQuarterData;" [ngValue]="item">{{item?.displayName}}</option>
            </select>
        </div>
    </div>
    <div class="table-width mb-0" #dataLoading="appIsLoading" [appIsLoading]="loadingService.isLoading(this)">
        <table class="table table-striped" aria-describedby="Invoice Claim History">
            <thead>
                <tr>
                    <th class="cm_12 cm_bold text-center" role="button" (click)="onSort('firmName')" scope="col">
                        {{'LeaderBoard.Position' | translate}}
                    </th>
                    <th class="cm_12 cm_bold text-center" role="button" (click)="onSort('firmName')" scope="col">
                        {{'LeaderBoard.FirmName' | translate}}
                        <!-- <cs-sort-icons *ngIf="sorter.showSortIcons('firmName')"
                            [sortAscending]="sorter.sortDirection"></cs-sort-icons> -->
                    </th>
                    <th class="cm_12 cm_bold text-center" role="button" (click)="onSort('userName')" scope="col">
                        {{'LeaderBoard.Username' | translate}}
                    </th>
                    <th class="cm_12 cm_bold text-center" role="button" (click)="onSort('firstName')" scope="col">
                        {{'LeaderBoard.FirstName' | translate}}
                    </th>
                    <th class="cm_12 cm_bold text-center" role="button" (click)="onSort('lastName')" scope="col">
                        {{'LeaderBoard.LastName' | translate}}
                    </th>
                    <th class="cm_12 cm_bold text-center" role="button" (click)="onSort('mobileNumber')" scope="col">
                        {{'LeaderBoard.MobileNumber' | translate}}
                    </th>
                    <th class=" cm_12 cm_bold text-center" role="button" (click)="onSort('regionName')" scope="col">
                        {{'LeaderBoard.RegionName' | translate}}
                        <!-- <cs-sort-icons *ngIf="sorter.showSortIcons('regionName')"
                            [sortAscending]="sorter.sortDirection"></cs-sort-icons> -->
                    </th>
                    <th class="cm_12 cm_bold text-center" role="button" (click)="onSort('targetAchievement')"
                        scope="col">
                        {{'LeaderBoard.InvoiceValue' | translate}}
                        <!-- <cs-sort-icons *ngIf="sorter.showSortIcons('targetAchievement')"
                            [sortAscending]="sorter.sortDirection">
                        </cs-sort-icons> -->
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let item of tableData; let index = index;">
                    <td class="text-center">{{ index + 1 }}</td>
                    <td class="text-center">{{item?.firmName}}</td>
                    <td class="text-center">{{item?.userName}}</td>
                    <td class="text-center">{{item?.firstName}}</td>
                    <td class="text-center">{{item?.lastName}}</td>
                    <td class="text-center">{{item?.mobileNumber}}</td>
                    <td class="text-center">{{item?.regionName}}</td>
                    <td class="text-center">{{item?.targetAchievement}}</td>
                </tr>
            </tbody>
        </table>
        <div class="invoiceSummaryNoData alert alert-danger" *ngIf="!dataLoading.appIsLoading && !tableData?.length && !hideTableCellOnLoad">
            {{'LeaderBoard.NoRecordsFound' | translate}}
        </div>
    </div>
    <div class="row" *ngIf="tableData && tableData.length > 0">
        <div class="col-lg-12 pagination-center-Bottom">
            <cs-custom-pagination [paginationDetails]="paginationDetails" (onChangeEvent)="onChange($event)">
            </cs-custom-pagination>
        </div>
    </div>
</div>